<template>
  <SvgIcon
    icon="x-mark"
    :class="[
      iconSizeClass,
      'transition-transform duration-200 hover:scale-125',
    ]"
    v-bind="$attrs"
    @click="emit('click')"
  />
</template>

<script setup>
import { computed } from 'vue';
import SvgIcon from '@/assets/SvgIcon.vue';

const SIZE_MAP = {
  4: 'h-2 w-2',
  6: 'h-3 w-3',
  8: 'h-4 w-4',
  10: 'h-5 w-5',
  12: 'h-6 w-6',
  14: 'h-7 w-7',
};

const props = defineProps({
  size: {
    type: Number,
    default: 8,
  },
});

const emit = defineEmits(['click']);

const iconSizeClass = computed(() => SIZE_MAP[props.size] ?? 'h-3 w-3');
</script>
